module.exports = require('./lib/errors');


//////////////////
// WEBPACK FOOTER
// ./~/json-rpc-error/index.js
// module id = 516
// module chunks = 0